import api from '@/api/index.js'

const emv_taps = {
  state: {
    loading: false,
    data: [],
    error: null
  },

  mutations: {
    SET_EMV_TAPS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_EMV_TAPS: (state, response) => {
      state.data = response
      state.loading = false
    },
    SET_EMV_TAPS_ERROR: (state, error) => {
      state.error = error
    },
    SET_EMV_TAPS_FILTER_DETAILS: (state, filterDetails) => {
      state.filterDetails = filterDetails
    }
  },

  actions: {
    LoadEmvTaps({commit}, query) {
      commit('SET_EMV_TAPS', [])
      commit('SET_EMV_TAPS_ERROR', null)
      commit('SET_EMV_TAPS_LOADING', true)
      return api.get(`emv-taps?limit=500&offset=0`)
        .then((response) => {
          commit('SET_EMV_TAPS', response)
        })
        .catch((error) => {
          commit('SET_EMV_TAPS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_EMV_TAPS_LOADING', false)
        })
    }
  }
}

export default emv_taps
